import React from 'react'

interface ShowIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const ShowIcon: React.FC<ShowIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 17,
  alt = 'Show icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 17'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M11.999 0C6.602 0 1.977 3.212.099 7.772L0 8.01l.098.238c1.879 4.56 6.504 7.771 11.901 7.771S22.021 12.807 23.9 8.248l.098-.238-.098-.238C22.021 3.212 17.396 0 11.999 0zm0 14.77c-4.801 0-8.9-2.8-10.644-6.76C3.1 4.05 7.198 1.25 12 1.25s8.9 2.8 10.644 6.76c-1.745 3.96-5.843 6.76-10.644 6.76zm0-10.832A4.067 4.067 0 007.928 8.01a4.067 4.067 0 004.071 4.07 4.067 4.067 0 004.071-4.07A4.067 4.067 0 0012 3.938zM9.178 8.01a2.817 2.817 0 012.821-2.822A2.817 2.817 0 0114.82 8.01 2.817 2.817 0 0112 10.83a2.817 2.817 0 01-2.821-2.82z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default ShowIcon
